const history = {
  table: {
    headers: {
      createdBy: 'Por',
      createdAt: 'Creado en',
      updatedAt: 'Última actualización',
      updatedBy: 'Por',
      oldValue: 'Valor anterior',
      newValue: 'Nuevo valor',
      date: 'Fecha',
      beforeCopy: {
        regular: 'Copiar',
        sessionId: 'Copiar ID de sesión',
      },
      afterCopy: 'Copiado',
    },
  },
};

export default history;
